module.exports = __webpack_public_path__ + "static/media/propic-6.c1c178b2.png";